import dayjs from 'dayjs';
import { Transform, Type } from 'class-transformer';
import { CarType } from './bundleTypes';
import { Region } from './orderTypes';

export type Role = 'ADMIN' | 'SENDER' | 'COURIER' | 'SENDER_ADMIN';

export class User {
  role: Role;
  email: string;
  emailVerified: boolean;
  firstName: string;
  lastName: string;
  phoneCode: string;
  phoneNumber: string;
  companyName: string;
  companyNumber: string;
  country: string;
  @Type(() => Date)
  @Transform(value => dayjs(value))
  created: dayjs.Dayjs;
  @Type(() => Date)
  @Transform(value => dayjs(value))
  lastSignedIn: dayjs.Dayjs;
  paymentByInvoiceAllowed: boolean;
  isCourier: boolean;
  isSorter: boolean;
  travelMode: CourierTravelMode;
  carType?: CarType;
  preferredGeoZones?: string[];
  plateNumbers?: string[];
  isLocked: boolean;
  accountId: number | null;
  etaOffsetSeconds: number | null;
  regions: Region[];
  limitedAccess: boolean;
  predictionModel?: string;

  fullName(): string {
    return `${this.firstName}${this.lastName ? ` ${this.lastName}` : ''}`;
  }
}

export class UserList {
  @Type(() => User)
  items: User[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;

  constructor() {
    this.items = [];
    this.page = 0;
    this.pageSize = 25;
    this.total = 0;
    this.totalPages = 0;
  }
}

export enum CourierTravelMode {
  None = 'NONE',
  Car = 'CAR',
  Bike = 'BIKE',
}

export enum RoleType {
  ADMIN = 'ADMIN',
  SENDER = 'SENDER',
  SENDER_ADMIN = 'SENDER_ADMIN',
  COURIER = 'COURIER',
}

export enum AccountCategory {
  SENDER = 'SENDER',
  COURIER = 'COURIER',
  NONE = 'NONE',
}

export enum CompensationModel {
  INDIVIDUAL = 'INDIVIDUAL',
  THREE_PL = 'THREE_PL',
  NONE = 'NONE',
}

export class Account {
  id: number;
  category: AccountCategory;
  name: string;
  email: string;
  streetName: string;
  streetNumber: string;
  postalCode: string;
  city: string;
  countryCode: string;
  phoneCode: string;
  phoneNumber: string;
  companyNumber: string;
  paymentByInvoiceAllowed: boolean;
  enabled: boolean;
  updated: string;
  compensationModel: CompensationModel;
}

export interface AccountType {
  id: number;
  category: AccountCategory;
  name: string;
  email: string;
  streetName: string;
  streetNumber: string;
  postalCode: string;
  city: string;
  countryCode: string;
  phoneCode: string;
  phoneNumber: string;
  companyNumber: string;
  paymentByInvoiceAllowed: boolean;
  enabled: boolean;
  updated: string;
  compensationModel: CompensationModel;
}

export type PartnerInviteResponse = {
  id: string;
  email: string;
};
